<div class="main-container">
  <div class="page-header mb-24">
    <h1 class="page-title">Patient Registration Center</h1>
    <p class="page-subtitle">Manage patient registrations and approvals</p>
  </div>

  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)"
    animationDuration="300ms" class="patient-tabs">

    <mat-tab label="Pending">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">hourglass_empty</mat-icon>
        <span>Pending</span>
        @if(pendingCount > 0) {
        <span class="rounded-icon-wrapper g-just-flex" style="
          right: 0px; flex: 1 1 20px; align-items: center;
          height: 20px; width: 20px;
          position: relative; top: 0px; margin-left: 6px;">
          <span class="tab-badge" style="
            font-size: 14px;
            line-height: 14px;
            color: var(--mat-sys-primary);
            font-weight: bold;
            
           
            ">{{pendingCount}}</span></span>
        }
      </ng-template>
    </mat-tab>

    <mat-tab label="Approved">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">check_circle</mat-icon>
        <span>Approved</span>
        @if(approvedCount > 0) {
        <span class="rounded-icon-wrapper g-just-flex" style="
          right: 0px; flex: 1 1 20px; align-items: center;
          height: 20px; width: 20px;
          position: relative; top: 0px; margin-left: 6px;">
          <span class="tab-badge" style="
            font-size: 14px;
           line-height: 14px;
            color: var(--mat-sys-primary);
            font-weight: bold;
            
           
            ">
            {{approvedCount}}</span></span>
        }
      </ng-template>
    </mat-tab>

    <mat-tab label="Archived">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">archive</mat-icon>
        <span>Archived</span>
      </ng-template>
    </mat-tab>

    <mat-tab label="Deceased">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">person_off</mat-icon>
        <span>Deceased</span>
        @if(deceasedCount > 0) {
        <span class="rounded-icon-wrapper g-just-flex" style="
          right: 0px; flex: 1 1 20px; align-items: center;
          height: 20px; width: 20px;
          position: relative; top: 0px; margin-left: 6px;">
          <span class="tab-badge" style="
            font-size: 14px;
           line-height: 14px;
            color: var(--mat-sys-primary);
            font-weight: bold;
           
           
            ">
            {{deceasedCount}}</span></span>
        }
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>